import { DocumentNode } from '@apollo/client';
import { ATCPageAutomatedSection } from '@features/add-to-cart-page/typings/AutomatedSection';
import { ATCPageInsuranceSection } from '@features/add-to-cart-page/typings/Insurance';
import { ATCPageOptionsRowSection } from '@features/add-to-cart-page/typings/OptionsRowSection';
import { ProductSummary } from '@features/add-to-cart-page/typings/Product';
import { ATCPageProductTypeSection } from '@features/add-to-cart-page/typings/ProductTypeSection';

export type AddToCartPageSectionProps = {
  product: ProductSummary;
  section:
    | ATCPageOptionsRowSection
    | ATCPageProductTypeSection
    | ATCPageAutomatedSection
    | ATCPageInsuranceSection;
  order: number;
  isBusiness: boolean;
  shouldUsePromotionalContent: boolean;
};

export type AddToCartPageSectionFragment = {
  document: DocumentNode;
  name: string;
};

export enum AddToCartPageSectionTypes {
  AUTOMATED_SECTION = 'ATCPageAutomatedSection',
  CLASSIFICATION_OPTIONS_ROW_SECTION = 'ATCPageClassificationOptionsRowSection',
  MANUAL_OPTIONS_ROW_SECTION = 'ATCPageManualOptionsRowSection',
  PRODUCT_TYPE_SECTION = 'ATCPageProductTypeSection',
  INSURANCE_SECTION = 'ATCPageInsuranceSection'
}

export enum AddToCartPageType {
  EMPLOYEE_ATC_PAGE = 'employee_atc_page',
  BUSINESS_ATC_PAGE = 'business_atc_page',
  CUSTOMER_ATC_PAGE = 'customer_atc_page'
}

export enum AddToCartPageState {
  DEFAULT = 'default',
  MANUAL = 'manual'
}

export enum AddToCartPageStepState {
  SINGLE_STEP = 'singlestep',
  MULTI_STEP = 'multistep'
}
